import { useEffect, useState } from "react";
import { STATUS, fmt } from "../constants";

function inicioSemana(d){
  const dt = new Date(d);
  const dia = dt.getDay();
  const diff = dia===0 ? -6 : 1-dia;
  dt.setDate(dt.getDate()+diff);
  dt.setHours(0,0,0,0);
  return dt;
}
function fimSemana(d){
  const inicio = inicioSemana(d);
  const fim = new Date(inicio);
  fim.setDate(fim.getDate()+6);
  fim.setHours(23,59,59,999);
  return fim;
}
function inicioMes(d){
  const dt = new Date(d.getFullYear(), d.getMonth(), 1);
  dt.setHours(0,0,0,0);
  return dt;
}
function fimMes(d){
  const dt = new Date(d.getFullYear(), d.getMonth()+1, 0);
  dt.setHours(23,59,59,999);
  return dt;
}

export default function Mapa({ordens}){
  const [periodo, setPeriodo] = useState("todos");
  const [tecnicoFiltro, setTecnicoFiltro] = useState("");
  const [buscaServico, setBuscaServico] = useState("");

  const tecnicosDisponiveis = [...new Set(ordens.map(o=>o.tecnico_nome).filter(Boolean))].sort();

  const agora = new Date();
  const hojeStr = agora.toISOString().slice(0,10);
  const iniSemana = inicioSemana(agora);
  const fimSem = fimSemana(agora);
  const iniMes = inicioMes(agora);
  const fimM = fimMes(agora);

  const ordensFiltradas = ordens.filter(o=>{
    if(periodo==="hoje" && o.data_agendada?.slice(0,10)!==hojeStr) return false;
    if(periodo==="semana"){
      if(!o.data_agendada) return false;
      const d = new Date(o.data_agendada);
      if(d<iniSemana || d>fimSem) return false;
    }
    if(periodo==="mes"){
      if(!o.data_agendada) return false;
      const d = new Date(o.data_agendada);
      if(d<iniMes || d>fimM) return false;
    }
    if(tecnicoFiltro && o.tecnico_nome!==tecnicoFiltro) return false;
    if(buscaServico && !(o.descricao||"").toLowerCase().includes(buscaServico.toLowerCase())) return false;
    return true;
  });

  useEffect(()=>{
    const init = () => {
      if(!window.L) return;
      const L=window.L, el=document.getElementById("mapa-servicos");
      if(!el) return;
      if(el._leaflet_id){el._leaflet_id=null;el.innerHTML="";}
      const map=L.map("mapa-servicos").setView([-23.5505,-46.6333],11);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",{attribution:"© OpenStreetMap"}).addTo(map);
      ordensFiltradas.forEach(o=>{
        if(!o.latitude||!o.longitude) return;
        const cor=STATUS[o.status]?.cor||"#6b7280";
        const icon=L.divIcon({html:`<div style="background:${cor};width:14px;height:14px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.3)"></div>`,iconSize:[14,14],className:""});

        const dataHora = o.data_agendada
          ? new Date(o.data_agendada).toLocaleString("pt-BR",{dateStyle:"short",timeStyle:"short"})
          : "Sem data agendada";
        const tecnico = o.tecnico_nome || "Sem tecnico definido";
        const servico = o.descricao || "Sem descricao";

        const popup = `
          <div style="min-width:180px">
            <strong>OS #${o.id}</strong><br/>
            ${o.cliente_nome}<br/>
            <span style="color:${cor};font-weight:600">${STATUS[o.status]?.l||o.status}</span>
            <hr style="margin:6px 0;border:none;border-top:1px solid #e5e7eb"/>
            <div style="font-size:12px;line-height:1.6">
              <div><i>Data:</i> ${dataHora}</div>
              <div><i>Tecnico:</i> ${tecnico}</div>
              <div><i>Servico:</i> ${servico}</div>
              <div><i>Valor:</i> R$ ${fmt(o.valor_total)}</div>
            </div>
          </div>
        `;

        L.marker([parseFloat(o.latitude),parseFloat(o.longitude)],{icon}).addTo(map)
          .bindPopup(popup);
      });
    };

    if(!document.getElementById("leaflet-css")){
      const link=document.createElement("link"); link.id="leaflet-css"; link.rel="stylesheet"; link.href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"; document.head.appendChild(link);
      const s=document.createElement("script"); s.src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"; s.onload=init; document.head.appendChild(s);
    } else init();
  },[ordensFiltradas]);

  return(
    <div className="mb-16">
      <div className="flex-row mb-12" style={{flexWrap:"wrap",gap:8,alignItems:"center"}}>
        <div className="flex-row" style={{gap:4}}>
          {[["todos","Todos"],["hoje","Hoje"],["semana","Esta semana"],["mes","Este mes"]].map(([v,l])=>(
            <button key={v} className={"btn btn-secondary"+(periodo===v?" aba-ativa":"")}
              style={{fontSize:11,padding:"4px 10px"}} onClick={()=>setPeriodo(v)}>{l}</button>
          ))}
        </div>
        <select className="form-select" style={{width:180,fontSize:12}} value={tecnicoFiltro} onChange={e=>setTecnicoFiltro(e.target.value)}>
          <option value="">Todos os tecnicos</option>
          {tecnicosDisponiveis.map(t=><option key={t} value={t}>{t}</option>)}
        </select>
        <input className="form-input" style={{width:220,fontSize:12}} placeholder="Buscar por servico..."
          value={buscaServico} onChange={e=>setBuscaServico(e.target.value)}/>
      </div>

      {!ordensFiltradas.some(o=>o.latitude)&&(
        <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:12,fontSize:13,marginBottom:8}}>
          Nenhuma OS com coordenadas cadastradas para esse filtro.
        </div>
      )}
      <div id="mapa-servicos" style={{height:450,borderRadius:8,border:"1px solid var(--z-border)"}}/>
    </div>
  );
}
